import React from 'react';
import ValueCell from './ValueCell';
import { HeadingSBold, CaptionBold } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/components/servicesTableCellsStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyle = makeStyles(styles);

interface IDividedCellProps {
	title: string;
	cells: Array<{
		value: string;
		title: string;
	}>;
}

const DividedCell = (props: IDividedCellProps) => {
	const classes = useStyle();
	return (
		<ValueCell
			value={
				<div className={classes.dividedCell}>
					{props.cells.map((cell, index) => (
						<div key={index}>
							<HeadingSBold disableMargin>{cell.value}</HeadingSBold>
							<CaptionBold disableMargin>{cell.title}</CaptionBold>
						</div>
					))}
				</div>
			}
			title={props.title}
		/>
	);
};

export default DividedCell;
